var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.33,
    y: 389.91,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.97,
    y: 398.37,
    width: 44.03,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.46,
    y: 399.19,
    width: 44.78,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.69,
    y: 389.66,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.79,
    y: 389.66,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 393.88,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 44,
    width: 380.06,
    height: 325.63,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.94,
    y: 44,
    width: 384.06,
    height: 325.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.08,
    y: 25.46,
    width: 303.79,
    height: 362.72,
    transform: "translate(457.79 -44.15) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.19,
    y: 204.57,
    width: 303.79,
    height: 4.49,
    transform: "translate(636.9 -223.27) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.36,
    y: 297.57,
    width: 375.23,
    height: 5.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.36,
    y: 74.18,
    width: 375.23,
    height: 14.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.09,28.67H31.76c0,71.47-3.34,271.81-3.34,271.81h23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,28.67H61.85C61.85,97.74,58,291.33,58,291.33h26.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,28.67H93.84C93.84,97.74,90,291.33,90,291.33h26.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.56,28.67H44.2c0,77.48-3.88,294.66-3.88,294.66H67.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,28.67H80.44c0,77.48-3.89,294.66-3.89,294.66h26.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.91,28.67H386.58c0,71.47-3.33,271.81-3.33,271.81h23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,28.67H416.68c0,69.07-3.89,262.66-3.89,262.66h26.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,28.67H448.66c0,69.07-3.88,262.66-3.88,262.66h26.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.38,28.67H399c0,77.48-3.88,294.66-3.88,294.66h26.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.62,28.67H435.26c0,77.48-3.88,294.66-3.88,294.66h26.8Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.35,
    y: 61.31,
    width: 1,
    height: 10.74,
    transform: "translate(201.6 357.71) rotate(-83.88)",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.32,95l-1-.11,1.14-10.64a14.93,14.93,0,0,0-3.26-11,15.12,15.12,0,0,0-3.18-3l.57-.82A16.34,16.34,0,0,1,316,72.63a15.91,15.91,0,0,1,3.47,11.76Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.87,102.13l3-27.67a12.54,12.54,0,0,1,13.78-11.11l64.25,6.88A12.57,12.57,0,0,1,316,84l-3,27.66a12.55,12.55,0,0,1-13.78,11.12l-1.34-.15c.77,4.56,3.28,10.5,9.71,17.31-13.23-4.67-20-12.08-23.47-18.78L235,115.91A12.56,12.56,0,0,1,223.87,102.13Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.35,86.1l-5.74-19.86-27-2.89a12.55,12.55,0,0,0-13.78,11.11l-3,27.67a12.5,12.5,0,0,0,3.68,10.24l37.24-10.76A12.57,12.57,0,0,0,273.35,86.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,85.79l-3.7-27.58a12.56,12.56,0,0,0-14.08-10.74l-64,8.59A12.56,12.56,0,0,0,177.5,70.14l3.7,27.57a12.56,12.56,0,0,0,14.07,10.75l1.34-.18c-.65,4.58-3,10.58-9.25,17.56,13.11-5,19.68-12.61,23-19.4l49-6.57A12.57,12.57,0,0,0,270.06,85.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.47,127.15l1.49-1.67c5-5.62,8.06-11.19,9-16.57l-.62.08a13.09,13.09,0,0,1-14.69-11.2L177,70.21a13.09,13.09,0,0,1,11.21-14.68l64-8.6a13.07,13.07,0,0,1,14.68,11.21l3.7,27.58a13.07,13.07,0,0,1-11.21,14.68l-48.69,6.54c-4.27,8.62-12.05,15.15-23.14,19.41Zm11.78-19.5-.1.71c-.75,5.26-3.42,10.69-7.93,16.14,9.84-4.19,16.77-10.34,20.62-18.3l.13-.26,49.27-6.61a12,12,0,0,0,10.28-13.47l-3.7-27.58A12,12,0,0,0,252.35,48l-64,8.6A12,12,0,0,0,178,70.06l3.7,27.58a12,12,0,0,0,13.47,10.28Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.22,79.35a6.62,6.62,0,1,1-7.62-5.43A6.61,6.61,0,0,1,209.22,79.35Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6,80A6.61,6.61,0,1,1,222,74.56,6.61,6.61,0,0,1,229.6,80Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,68.8a6.62,6.62,0,1,1-7.62-5.43A6.61,6.61,0,0,1,248,68.8Z",
    style: {
      fill: "#D175F7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,169.74l2.47,2.9,2.57,3c1.71,1.95,3.48,3.85,5.24,5.66.88.9,1.77,1.78,2.66,2.61s1.77,1.64,2.65,2.35,1.75,1.35,2.53,1.89a14.18,14.18,0,0,0,1.9,1.09l-1.46-.22a1.8,1.8,0,0,0-1.22.26c0,.05.23,0,.55-.19a13.12,13.12,0,0,0,2.43-1.85,59.61,59.61,0,0,0,5.43-5.9c1.81-2.17,3.57-4.48,5.33-6.82l5.22-7.09.07-.1a4.27,4.27,0,0,1,7.51,3.81,92,92,0,0,1-3.32,8.82c-1.24,2.88-2.61,5.72-4.17,8.54a57.21,57.21,0,0,1-5.56,8.4,28.89,28.89,0,0,1-4.21,4.24,15.61,15.61,0,0,1-3.35,2.08,12.21,12.21,0,0,1-5.61,1.16,5.69,5.69,0,0,1-1-.13l-.43-.1a24.65,24.65,0,0,1-5.78-2.12,40.28,40.28,0,0,1-4.47-2.66,65.08,65.08,0,0,1-7.37-5.88c-2.26-2-4.34-4.18-6.34-6.36-1-1.1-2-2.2-2.92-3.35-.47-.57-.94-1.13-1.4-1.72l-1.42-1.85a8.52,8.52,0,0,1,13.24-10.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62,165.44c.54-4.2,8.16-6.14,8.16-6.14l4.46-2a3.36,3.36,0,0,1,4.18,1.23l2.27,3.47a3.37,3.37,0,0,1-1,4.71l-4.09,2.56a6.08,6.08,0,0,1-2.4.86l-3.48.45a7.78,7.78,0,0,1-7.54-3.51l-.21-.33A2,2,0,0,1,210.62,165.44Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05,164c11.81-1.47,28.7-1.33,40,.62a13.7,13.7,0,0,1,11.12,11.53c2.38,17.09.33,47-1.19,77-25.84,8.85-53.12-.12-53.12-.12-.94-6.07,1.17-25.94,2.59-36.55-2.13-11-6.65-23.51-9.64-38.06A11.91,11.91,0,0,1,126.05,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,163.49a12.23,12.23,0,0,1,2.87,6.57c1.21,6.94-.17,17.63-3.82,29.9-3.5-9.88-11-23-15.67-30.55-2.19-3.6-3.73-6-3.87-6.18v0A42.64,42.64,0,0,1,156.51,163.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,144.2a4.25,4.25,0,1,1-4.25-4.25A4.24,4.24,0,0,1,143.19,144.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27,128.49c-.2,3.9-2.68,6.95-5.54,6.81s-5-3.44-4.81-7.34,2.68-7,5.54-6.81S165.47,124.58,165.27,128.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.18,140.19l14.58,11.95c-1.89,5-.49,10,3.75,11.35.7,2.18-1.79,4.47-4.16,6.68-5.5-.69-12.07-1.73-15.42-6.34C138,160.22,139.59,147.61,138.18,140.19Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12,167.69a10.23,10.23,0,0,1-2.79,4.21c-2.05,0-5.05-2.31-5.05-2.31s1.16-3.26,2.79-3.92C154.22,166.69,155.12,167.69,155.12,167.69Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,170.48a3,3,0,0,1,2.26-.57c2.69,3.82,4.4,9.76,6.06,16.61a115.23,115.23,0,0,1-3.2,13.44,104.92,104.92,0,0,0-5.23-11.89A71.22,71.22,0,0,0,150.44,170.48Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76,152.14l-8.6-7a16.14,16.14,0,0,0-.51,4.7c.22,3.2,4.57,6.7,8.3,7.23A12,12,0,0,1,152.76,152.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58,131.3c1.41,9.7,1.75,15.46,7.09,20,8,6.85,19.72,1.27,21.24-8.68,1.37-9-1.17-23.32-11-26.32A13.51,13.51,0,0,0,135.58,131.3Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36,131.64a5,5,0,0,0-3.85-.23A10.05,10.05,0,0,0,148.36,131.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,132.56a4.16,4.16,0,0,0-3.44.66A8.21,8.21,0,0,0,148.25,132.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,138.19c-1-.14-2,.09-1.87,1.86A3.22,3.22,0,0,1,146.53,138.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.76,138.16c5.37-1.64,5.81-8.64,3.61-9.93,4.5.77,9.16-5.32,7.41-7.38,11,6,19,2.82,15.47-5.81-4.15-10.09-16.54-6-16-3.51-6.8-4-18.31.86-13.42,5.68-6.7-2.1-11.75,4.6-7.66,9.71-8.57,4.46-.3,14.58,3.1,13.76C129.84,144,138.58,147.62,137.76,138.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,142.89s-2.92-1.26-11.42-3c.59,2.53,2.11,4.81,6.47,5.67S158.06,142.89,158.06,142.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,143.3a9.07,9.07,0,0,1,4.55,2.1,5,5,0,0,1-2.84.14,9,9,0,0,1-4.54-2.1A4.93,4.93,0,0,1,151.41,143.3Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.68,142.75a1.65,1.65,0,0,1-1.53.87,50.55,50.55,0,0,1-7.42-2.14,2.59,2.59,0,0,1-1.73-1.54A78.13,78.13,0,0,1,157.68,142.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,137.85a8.38,8.38,0,0,0,3.92,5.17c2.59,1.49,4.64-.65,4.55-3.47-.08-2.54-1.52-6.37-4.43-6.7S131,135.18,131.64,137.85Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.93,131.66c.07.79.54,1.4,1.06,1.35s.89-.73.82-1.52-.54-1.4-1.06-1.36S150.86,130.87,150.93,131.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,131.43c.07.79.54,1.4,1.06,1.35s.89-.73.82-1.53-.54-1.39-1.06-1.35S159.85,130.63,159.91,131.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,132.5s2.19,4.41,4.37,6.44c-1.3,1.44-3.74,1.06-3.74,1.06Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.34,129.65a.53.53,0,0,1,.11.21.47.47,0,0,1-.37.55,4.65,4.65,0,0,1-4.16-1,.45.45,0,0,1,0-.65.47.47,0,0,1,.67,0h0a3.75,3.75,0,0,0,3.31.78A.47.47,0,0,1,153.34,129.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,127.81a.47.47,0,0,1-.43-.06,3.68,3.68,0,0,0-3.31-.66.47.47,0,0,1-.6-.28.48.48,0,0,1,.28-.6,4.6,4.6,0,0,1,4.19.78.47.47,0,0,1,.09.66A.5.5,0,0,1,164.11,127.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,163.21v0c.14.21,1.68,2.58,3.87,6.18a17,17,0,0,0,7.85,4.12c-.44-1.45.86-6.35,2.3-7.86C146.65,165.84,142,165.26,136,163.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.07,165.67a12.56,12.56,0,0,1,6.75,7.19,4.69,4.69,0,0,0,2.56-2.8,12.23,12.23,0,0,0-2.87-6.57C155.72,164.5,153.58,165.48,150.07,165.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,180.36l-2.25,3.76L126.22,188c-1.5,2.57-2.92,5.18-4.28,7.75s-2.57,5.17-3.57,7.63c-.5,1.23-.89,2.44-1.21,3.5a17.66,17.66,0,0,0-.5,2.33,13.2,13.2,0,0,0,1.76,5.58,51.15,51.15,0,0,0,4.46,6.9,163.12,163.12,0,0,0,11.68,13.53l.13.14a4.26,4.26,0,0,1-5.14,6.66,79.75,79.75,0,0,1-8.4-5.33,80.9,80.9,0,0,1-7.77-6.36,54.22,54.22,0,0,1-7.07-7.94,36,36,0,0,1-3-5.11,22,22,0,0,1-2-6.67,25,25,0,0,1,.3-7,42.74,42.74,0,0,1,1.37-5.54,77.91,77.91,0,0,1,3.76-9.68c1.38-3.07,2.92-6,4.51-8.87.82-1.43,1.63-2.86,2.49-4.25s1.71-2.74,2.72-4.23a8.52,8.52,0,0,1,14.38,9.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86,169.15a15.63,15.63,0,0,1,.62-4.69c2.57-.69,9.54,4.2,10.6,6.44-.45,1.29-3.4,4-3.4,4C214.49,172.9,210.55,170.58,208.86,169.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.93 254.44 91.26 254.44 91.26 246.11 213.93 236.11 213.93 254.44",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.59 416.24 109.59 416.24 99.59 254.44 205.59 254.44 195.59 416.24",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.6,
    cy: 333,
    r: 26.33,
    transform: "translate(-5.64 2.64) rotate(-0.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.84 266.68 99.81 257.92 99.59 254.44 205.59 254.44 204.84 266.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,237.1a2,2,0,0,1,.34-1.31l2.26-3.34a2,2,0,0,1,2-.87l3.38.52a23,23,0,0,1,9.18,3.53l.91.6a3.37,3.37,0,0,1,.92,4.73l-2.35,3.42a3.37,3.37,0,0,1-4.22,1.13l-4.4-2.07S127.11,241.31,126.68,237.1Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47,230a15.65,15.65,0,0,1,4.65.87c.54,2.61-4.73,9.3-7,10.23-1.27-.52-3.86-3.62-3.86-3.62C126.41,235.4,129,231.59,130.47,230Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,234.06a.51.51,0,0,1-.43-.76c.3-.5,7.17-12.33-5.32-20.24a.5.5,0,0,1,.54-.85c13.31,8.44,5.72,21.47,5.64,21.6A.51.51,0,0,1,205,234.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,237.57l16.67-1.35s-2-3.39-8.6-2.66S196,237.57,196,237.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.29,213.09h0a1.51,1.51,0,0,1-2.1.36l-2.43-1.73a1.51,1.51,0,0,1-.36-2.1h0a1.51,1.51,0,0,1,2.1-.36l2.44,1.73A1.51,1.51,0,0,1,200.29,213.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.18,127.17c-11.58,5.89-16.64,14.39-14.08,22.39s-3,9.22-2.28,19.77,6.83,12.23,3.28,17.23,3.61,22.22,23.14,13.11,27.83-25.44,22.79-34.94S361,152,361,139.76C361,129.16,352.27,120,338.18,127.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,195.46l.91,1.55a4.85,4.85,0,0,0,3.38,2.29l7.86,1.24,3.22-2.57c-1.85-3.72-7.17-6.72-7.17-6.72l-1.41-1a3.31,3.31,0,0,0-4,.12l-2.37,2.19A2.26,2.26,0,0,0,281.29,195.46Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,188.86c-1.05,2.41-2.16,4.53-3.32,6.75s-2.41,4.33-3.73,6.44-2.71,4.19-4.17,6.23-3.06,4-4.71,5.95l-.17.2a4.57,4.57,0,0,1-1.18,1,9.22,9.22,0,0,1-3.26,1.08,9.76,9.76,0,0,1-3-.05,14.5,14.5,0,0,1-4.44-1.6,28.57,28.57,0,0,1-6-4.59,50.27,50.27,0,0,1-4.59-5.17,54,54,0,0,1-3.87-5.6,2.74,2.74,0,0,1,4.18-3.46l.09.08c1.51,1.36,3.11,2.79,4.69,4.1s3.19,2.59,4.81,3.7a23.17,23.17,0,0,0,4.69,2.65,4.59,4.59,0,0,0,1.69.37c.37,0,.19-.13,0-.06L309.42,208a129.39,129.39,0,0,0,7.27-11.54c1.12-2,2.23-4,3.3-6.08s2.13-4.15,3.1-6.09l.05-.11a5.5,5.5,0,0,1,10,4.65Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,174.26c-14.83-2.83-26,23.54-26.44,29.45.5,5.35,10,5.71,10,5.71S342.09,193.28,338,174.26Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.32,209.1a9.48,9.48,0,0,1-2,1.77.48.48,0,0,1-.2.07c-.88.07-7,.41-10.62-4.18a.42.42,0,0,1-.1-.26,10.11,10.11,0,0,1,.6-3.88.47.47,0,0,1,.73-.21c1.53,1.17,6.4,4.67,11.32,5.92A.47.47,0,0,1,323.32,209.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,252.33s-7.22-15.19-7.42-25c-6.3,0-42.36-1.52-43.33,6.63.06.53-.65,11.6-1.61,13.51C327.94,259.31,354,256.65,374,252.33Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,252.33s-7.22-15.19-7.42-25c-6.3,0-42.36-1.52-43.33,6.63.06.53-.65,11.6-1.61,13.51C327.94,259.31,354,256.65,374,252.33Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.94,189.35a179,179,0,0,0,.72,18c.79,13.1.34,23,1.18,28.07a30.67,30.67,0,0,0,10.51,2.89,15.84,15.84,0,0,1,2.44-3.4c.91.73,3.75,2.81,5.46,3.06,7.84-.59,22.63-2.82,26.43-6.26-1.84-11-4-20.83,2.43-46A9.2,9.2,0,0,0,361.93,174c-1.56-.12-3.22-.21-4.92-.25a125.78,125.78,0,0,0-17.9.47c-1.94.23-3.95.52-5.87.84A14.84,14.84,0,0,0,320.94,189.35Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,189.31a70.3,70.3,0,0,0,3.73,17c.33-3.28.88-6.93,1.71-11.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,239.92l.85-1.58a4.81,4.81,0,0,1,3.28-2.42l7.8-1.56,3.33,2.44c-1.7,3.79-6.9,7-6.9,7l-1.37,1a3.3,3.3,0,0,1-4,0l-2.45-2.09A2.26,2.26,0,0,1,357.1,239.92Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.84,185.25c.47.62.83,1.11,1.21,1.65s.73,1.07,1.09,1.61c.71,1.08,1.38,2.16,2,3.26q1.95,3.3,3.57,6.8a66.34,66.34,0,0,1,2.89,7.2,58.46,58.46,0,0,1,2.06,7.66l.05.24,0,.13,0,.24a9.06,9.06,0,0,1,.1,1,10.94,10.94,0,0,1,0,1.63,13.51,13.51,0,0,1-.55,2.71,22.07,22.07,0,0,1-1.85,4.17,43.25,43.25,0,0,1-4.6,6.5,78,78,0,0,1-10.81,10.47,2.74,2.74,0,0,1-3.92-3.77l.06-.07c2.79-3.74,5.57-7.65,7.95-11.51a44.19,44.19,0,0,0,3.06-5.75,13.31,13.31,0,0,0,.81-2.54,4.3,4.3,0,0,0,.07-.85c0-.09,0-.16,0-.17s0,0,0,.05,0,0,0,0l0-.1-.06-.19a64.85,64.85,0,0,0-2.18-6.15c-.88-2.05-1.79-4.09-2.84-6.08s-2.13-4-3.3-5.92c-.58-1-1.17-1.93-1.79-2.87l-.92-1.4-.88-1.29-.15-.22a5.49,5.49,0,0,1,8.92-6.41Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.24,173.94c15-1.57,23.89,25.65,23.85,31.58-.95,5.28-10.48,4.84-10.48,4.84S355.58,192.54,361.24,173.94Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.33,186.46a.5.5,0,0,1-.11-1A33,33,0,0,0,348.75,179a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7,33.74,33.74,0,0,1-11,6.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76,185.7a.51.51,0,0,1-.37-.17c-1.16-1.29-2.6-5.5-.86-9.79a.5.5,0,0,1,.93.37,9.48,9.48,0,0,0,.67,8.75.5.5,0,0,1-.37.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,153.53c-.91,5.9-1.71,16.49,2.13,20.24,0,0-5.47-.68-16.87,6.78-3.48-4.72-1-6.32-1-6.32,6.5-1.7,6.46-5.72,5.19-10.08Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.55,179.05c3.83.44,5.17,6.17,5.17,6.17s9-6.71,11.78-11.36a37.85,37.85,0,0,1-3.4-2S343.72,176.79,341.55,179.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,178.53s-3.28,1-4.35,5.64c-1.09-8.38,2.8-9.91,2.8-9.91a4.9,4.9,0,0,1,3.43-.59A4.09,4.09,0,0,0,337.91,178.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.58,157.86l-6.27,6.28a17.46,17.46,0,0,1,.66,3.13c2.43-.63,5.68-3.7,5.85-6.3A9,9,0,0,0,349.58,157.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,141.5c-.71,9.43-.81,13.43-5.59,18.45-7.2,7.56-18.49,5.24-20.58-4.07-1.88-8.38-.4-22.41,8.78-26.52A12.12,12.12,0,0,1,357.5,141.5Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,131.25c-7,8.24,8.14,14.5,9.15,23.92C361.12,144,358.52,124.89,350.68,131.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.21,131.78c-9.73,2.55-12.49,1.61-14.67,1.33-2.33,2.53-17,8.37-14.61.39,1.08-3.67,7.44-12.83,19.05-12.72S364.82,129.28,355.21,131.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,132.89h-.07a.25.25,0,0,1-.17-.32c.54-1.78-.08-3.66-1.75-5.3-2.81-2.75-8.5-4.62-13.95-2.86a.23.23,0,0,1-.31-.16.24.24,0,0,1,.16-.31c5.63-1.83,11.53.12,14.45,3,1.81,1.77,2.47,3.83,1.88,5.8A.25.25,0,0,1,351.61,132.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.7,131.7h0a.25.25,0,0,1-.21-.28c.42-2.64-1.67-5.19-5.32-6.5a.25.25,0,1,1,.17-.47c3.88,1.39,6.1,4.16,5.65,7.05A.26.26,0,0,1,355.7,131.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,144.66c0,.8-.46,1.46-1,1.48s-.9-.62-.87-1.41.46-1.45,1-1.47S343.05,143.87,343,144.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,145.15c0,.8-.45,1.46-1,1.48s-.89-.61-.87-1.41.46-1.45,1-1.47S333.55,144.36,333.52,145.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,143.78,331,143.3S331.94,144.76,332.88,143.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.13,146.36a23.14,23.14,0,0,1-2.92,5.17A3.14,3.14,0,0,0,336,152Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08,154.49a7.35,7.35,0,0,1-1.31-.06.2.2,0,0,1-.18-.26.25.25,0,0,1,.27-.2,6.6,6.6,0,0,0,5.44-1.75.22.22,0,1,1,.33.3A7,7,0,0,1,340.08,154.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.17,151.21a6.47,6.47,0,0,1-4.16,3.22c-2.19.44-3-2.09-2.11-4.52.79-2.19,2.87-5.06,5-4.39S360.39,149.1,359.17,151.21Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,139.65a.4.4,0,0,1-.31-.16,3.43,3.43,0,0,0-2.92-1.37.43.43,0,0,1-.49-.39.51.51,0,0,1,.44-.52,4.24,4.24,0,0,1,3.71,1.68.47.47,0,0,1-.1.65A.47.47,0,0,1,344,139.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.74,141a.42.42,0,0,1-.32-.1.45.45,0,0,1,0-.64,4.87,4.87,0,0,1,3.9-1.84.42.42,0,0,1,.38.5.51.51,0,0,1-.53.42,3.87,3.87,0,0,0-3.07,1.49A.51.51,0,0,1,330.74,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,143.29l-1.84-.48S341.45,144.27,342.38,143.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.62,182.47a11.47,11.47,0,0,1,2.14.47.85.85,0,0,1,.59.84c0,.84-.06,2.35,0,3.1,0,1.06-3.28,2.15-3.28,2.15s-1.89-1.77-1.49-3.19a20.07,20.07,0,0,1,1.17-2.9A.87.87,0,0,1,337.62,182.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.17,215c-1.27-9.61-.38-28,.77-27.7-.73-.2-1.45-.42-2.18-.64-2.24,2.25-5.76,14.48-6.56,28.25a25.63,25.63,0,0,0,5.79,11.6C335.93,226.45,337.18,220.13,338.17,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,209.89a9.49,9.49,0,0,0,1.82,1.94.46.46,0,0,0,.19.08c.87.15,7,1,10.93-3.26a.44.44,0,0,0,.13-.25,9.94,9.94,0,0,0-.27-3.91.46.46,0,0,0-.71-.28c-1.63,1-6.77,4.11-11.78,4.94A.47.47,0,0,0,373,209.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.07 254.44 408.74 254.44 408.74 246.11 286.07 236.11 286.07 254.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.4 416.24 390.4 416.24 400.4 254.44 294.4 254.44 304.4 416.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.4,
    cy: 333,
    r: 26.33,
    transform: "translate(8.55 674.7) rotate(-89.03)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.16 266.68 400.19 257.92 400.4 254.44 294.4 254.44 295.16 266.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,234.06a.51.51,0,0,1-.43-.25c-.08-.13-7.67-13.16,5.64-21.6a.49.49,0,0,1,.69.16.5.5,0,0,1-.15.69c-12.5,7.92-5.62,19.74-5.32,20.24a.51.51,0,0,1-.43.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,237.57l-16.67-1.35s2-3.39,8.6-2.66S304,237.57,304,237.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71,213.09h0a1.51,1.51,0,0,0,2.1.36l2.43-1.73a1.51,1.51,0,0,0,.36-2.1h0a1.51,1.51,0,0,0-2.1-.36L300.06,211A1.51,1.51,0,0,0,299.71,213.09Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile-2.ed59d2f95e81854a30f7a22093b0e9a9.svg";
export { ForwardRef as ReactComponent };